module.exports = __webpack_public_path__ + "img/logo_inicial.ffcc6c45.png";